<body>
  <div class="flex-container">
    <h1>Add Location Details</h1>
    <div class="input-container">
      <span class="p-input-icon-left search-box">
        <i class="pi pi-search"></i>
        <input type="text" pInputText placeholder="Search" id="search-box" class="search-input"
          [ngStyle]="{ width: '350px' }" />
      </span>
    </div>
    <div class="main-content">
      <div class="address-map-container">
        <div style="display: flex; align-items: center;">
          <i class="pi pi-map-marker icon"></i>
          <div class="py-0">

            <h3 style="margin-top: 16px;">Address</h3>
            <p>{{ address }}</p>
          </div>
        </div>
        <div id="map" class="map"></div>
      </div>
    </div>
    <button pButton color="primary" class="btn-primary mt-6" (click)="saveLocation()">Next <i
        class="pi pi-arrow-right arrow-icon" style="margin-left: 8px;"></i>
    </button>
  </div>
</body>